import { isPresent } from '@mbfab/shared'

import { CompactDateInput } from '@/components/ui/date-input'
import { CompactFormField } from '@/components/ui/form'

// 使い方のルール: docs/develop/client_ui/components/form.md

// 絞り込みバーの日付範囲（自〜至）入力。ミルシート一覧・剪断証明書一覧の絞り込みバーに
// ほぼ同一の実装が重複していたため共通化した
// （docs/develop/client_ui/README.md「このガイドラインを更新するとき」）
export function DateRangeField({
  idPrefix,
  label,
  gte,
  lte,
  onChange,
  testIdPrefix,
  className = 'sm:col-span-2',
}: {
  idPrefix: string
  label: string
  gte: string | undefined
  lte: string | undefined
  onChange: (next: { gte: string | undefined; lte: string | undefined }) => void
  testIdPrefix: string
  /** 既定は詳細絞り込みの grid で2列分取る。FilterBar の `primaryFilters` に置くときは幅（`sm:w-80` 等）を渡す */
  className?: string
}) {
  return (
    <CompactFormField id={`${idPrefix}From`} label={label} className={className}>
      <div className="grid min-w-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-1.5">
        <CompactDateInput
          id={`${idPrefix}From`}
          aria-label={`${label}（自）`}
          value={isPresent(gte) ? gte.slice(0, 10) : ''}
          wrapperClassName="min-w-0"
          onChange={(e) => {
            onChange({ gte: e.target.value === '' ? undefined : `${e.target.value}T00:00:00.000Z`, lte })
          }}
          data-testid={`${testIdPrefix}-${idPrefix}-from`}
        />
        <span className="text-muted-foreground">〜</span>
        <CompactDateInput
          id={`${idPrefix}To`}
          aria-label={`${label}（至）`}
          value={isPresent(lte) ? lte.slice(0, 10) : ''}
          wrapperClassName="min-w-0"
          onChange={(e) => {
            onChange({ gte, lte: e.target.value === '' ? undefined : `${e.target.value}T00:00:00.000Z` })
          }}
          data-testid={`${testIdPrefix}-${idPrefix}-to`}
        />
      </div>
    </CompactFormField>
  )
}
